import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import UserService from "../services/UserService";

export const UserContext = createContext("UserContext");

const UserContextProvider = ({ children }) => {
	const [userList, setUserList] = useState([]);
	const [totalElements, setTotalElements] = useState(0);
	const [loadingUserList, setLoadingUserList] = useState(false);
	const [userListErrorMsg, setUserListErrorMsg] = useState("");

	const getUserList = async (params) => {
		setLoadingUserList(true);
		setUserListErrorMsg("");
		try {
			const response = await UserService.getUsersList(params);
			setUserList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setUserListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingUserList(false);
		}
	};

	return (
		<UserContext.Provider
			value={{
				getUserList,
				userList,
				loadingUserList,
				userListErrorMsg,
				totalElements,
			}}
		>
			{children}
		</UserContext.Provider>
	);
};

export default UserContextProvider;
